import { Navigate, useRoutes } from 'react-router-dom';
import EnterReceipts from 'src/pages/EnterReceipts';
import AuthGuard from './components/guards/AuthGuard';
import ActionRequiredInvoices from './pages/ActionRequiredInvoices';
import ComposeMessagePage from './pages/ComposeMessage';
import EdiAdminTools from './pages/EdiAdminTools';
import Elmah from './pages/Elmah';
import EnterInvoices from './pages/EnterInvoices';
import InvoiceDetails from './pages/InvoiceDetails';
import InvoiceScanManager from './pages/InvoiceScanManager';
import ManageEmails from './pages/ManageEmails';
import ManageSuppliers from './pages/ManageSuppliers';
import NotFound from './pages/NotFound';
import PunchoutOrderGuide from './pages/PunchoutOrderGuide';
import ReceiptDetails from './pages/ReceiptDetails';
import ScanManager from './pages/ScanManager';
import SearchProducts from './pages/SearchProducts';
import ShoppingCart from './pages/ShoppingCart';
import VarianceDetails from './pages/VarianceDetails';
import Variances from './pages/Variances';
import ViewAccrualReport from './pages/ViewAccrualReport';
import ViewBudgetPeriod from './pages/ViewBudgetPeriod';
import ViewCatalogProducts from './pages/ViewCatalogProducts';
import ViewCatalogs from './pages/ViewCatalogs';
import ViewCheckbook from './pages/ViewCheckbook';
import ViewCheckbookConfiguration from './pages/ViewCheckbookConfiguration';
import ViewDepartments from './pages/ViewDepartments';
import ViewInvoices from './pages/ViewInvoices';
import { ViewMessagesInbox, ViewMessagesOutbox } from './pages/ViewMessages';
import ViewPeriods from './pages/ViewPeriods';
import ViewReceipts from './pages/ViewReceipts';
import ViewRecommendedItems from './pages/ViewRecommendedItems';
import ViewShoppingLists from './pages/ViewShoppingLists';
import ViewShoppingListsProducts from './pages/ViewShoppingListsProducts';
import WorkArea from './pages/WorkArea';

const Router = () =>
  useRoutes([
    {
      path: '',
      element: <AuthGuard />,
      children: [
        { path: '', element: <Navigate to="po" /> },
        { path: 'view-receipts', element: <ViewReceipts /> },
        { path: 'view-messages-outbox', element: <ViewMessagesOutbox /> },
        { path: 'view-messages-inbox', element: <ViewMessagesInbox /> },
        { path: 'compose-message', element: <ComposeMessagePage /> },
        { path: 'po/receiptdetails', element: <ReceiptDetails /> },
        { path: 'po', element: <EnterReceipts /> },
        { path: 'create-receipt', element: <EnterReceipts /> },
        { path: 'view-invoices', element: <ViewInvoices /> },
        { path: 'enter-invoice', element: <EnterInvoices /> },
        { path: 'invoicedetails', element: <InvoiceDetails /> },
        { path: 'scan-manager-invoices', element: <InvoiceScanManager /> },
        { path: 'scan-manager-receipts', element: <ScanManager isInvoices={false} /> },
        { path: 'action-required-invoices', element: <ActionRequiredInvoices /> },
        { path: 'variances', element: <Variances /> },
        { path: 'variance-details', element: <VarianceDetails /> },
        { path: 'view-checkbook', element: <ViewCheckbook /> },
        { path: 'MPADetails', element: <ViewBudgetPeriod /> },
        { path: 'view-edit-departments', element: <ViewDepartments /> },
        { path: 'view-edit-glperiods', element: <ViewPeriods /> },
        { path: 'view-checkbook-configuration', element: <ViewCheckbookConfiguration /> },
        { path: 'accrual-report', element: <ViewAccrualReport /> },
        { path: 'view-catalog-products', element: <ViewCatalogProducts /> },
        { path: 'product-search', element: <SearchProducts /> },
        { path: 'work-area', element: <WorkArea /> },
        { path: 'manage-email', element: <ManageEmails /> },
        { path: 'edi-admin-tools', element: <EdiAdminTools /> },
        { path: 'view-recommended-items', element: <ViewRecommendedItems isInternal={false} /> },
        { path: 'manage-suppliers', element: <ManageSuppliers /> },
        { path: 'view-catalogs', element: <ViewCatalogs /> },
        { path: 'view-shopping-lists', element: <ViewShoppingLists /> },
        { path: 'view-shopping-list-products', element: <ViewShoppingListsProducts /> },
        { path: 'shopping-cart', element: <ShoppingCart /> },
        { path: 'punchout-order-guide', element: <PunchoutOrderGuide /> },
      ],
    },
    {
      path: '',
      children: [{ path: 'elmah', element: <Elmah /> }],
    },
    { path: '*', element: <NotFound /> },
  ]);

export default Router;
